export default __webpack_public_path__ + "static/media/student-sample.48d756ab.zip";